import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import * as globals from './components/GlobalScripts.js';
import './styles/GlobalStyles.css';
import Admin from './pages/Admin';
import Admin_home from './pages/admin/Admin_home';
import Admin_productos from './pages/admin/Admin_productos';
import Admin_productos_edit from './pages/admin/Admin_productos_edit';
import Admin_ventas from './pages/admin/Admin_ventas';
import Admin_ventas_view from './pages/admin/Admin_ventas_view';
import Admin_clientes from './pages/admin/Admin_clientes';
import Admin_clientes_edit from './pages/admin/Admin_clientes_edit';
import Admin_galeria from './pages/admin/Admin_galeria';
import Home from './pages/Home';
import Categorias from './pages/Categorias';
import Colecciones from './pages/Colecciones';
import Productos from './pages/Productos';
import Contacto from './pages/Contacto';
import Sobre_mi from './pages/Sobre_mi';
import Carrito from './pages/Carrito';
import Comprar from './pages/Comprar';
import TY from './pages/TY';
import Login from './pages/Login';
import Login_Code from './pages/Login_Code';
import ScrollToTop from './pages/ScrollToTop';

const PrivateRouteAdmin = ({ children }) => {
  const user = JSON.parse(localStorage.getItem('user'));

  return globals.isAuthenticated() && user?.rol == 4 ? children : <Navigate to="/login" replace />;
};

function App() {
  let user = JSON.parse(localStorage.getItem('user'));

  //localStorage.setItem('path_api', 'http://localhost/ecommerce/backend');
  localStorage.setItem('path_api', 'https://ecommerce.zadrigman.com/backend');

  useEffect(() => {
    globals.closeViewCharge();
  }, []);

  return (
    <>
      <Router>
        <ScrollToTop />
        <Routes>
          <Route
            path="/admin/*"
            element={
              <PrivateRouteAdmin>
                <Admin />
              </PrivateRouteAdmin>
            }
          >
            <Route index element={<Admin_home />}></Route>
            <Route path="productos" element={<Admin_productos />}></Route>
            <Route path="productos/:id" element={<Admin_productos_edit />}></Route>
            <Route path="ventas" element={<Admin_ventas />}></Route>
            <Route path="ventas/:id" element={<Admin_ventas_view />}></Route>
            <Route path="clientes" element={<Admin_clientes />}></Route>
            <Route path="clientes/:id" element={<Admin_clientes_edit />}></Route>
            <Route path="galeria" element={<Admin_galeria />}></Route>
          </Route>
          {/* 
<Route path="/user/" element={isAuthenticated() && user?.lvl === 1 ? <User /> : <Navigate to="/login" replace />}>
<Route index element={<User_home/>}></Route>
<Route path="/user/compras" element={<User_compras/>}></Route>
</Route> */}
          <Route path="/" element={<Home />}></Route>
          <Route path="/categorias/:id" element={<Categorias />}></Route>
          <Route path="/colecciones/:id" element={<Colecciones />}></Route>
          <Route path="/productos/:id" element={<Productos />}></Route>
          <Route path="/contacto" element={<Contacto />}></Route>
          <Route path="/sobre-mi" element={<Sobre_mi />}></Route>
          <Route path="/carrito" element={<Carrito />}></Route>
          <Route path="/comprar" element={<Comprar />}></Route>
          <Route path="/TY" element={<TY />}></Route>
          <Route path="/login" element={<Login />}></Route>
          <Route path="/login/code" element={<Login_Code />}></Route>
        </Routes>
      </Router>
    </>
  );
}

export default App;
